<div class="container">
  <div
    *ngFor="let field of field?.fieldGroup; let i = index"
    class="row quickorder-textbox"
    [attr.data-testing-id]="'quickorder-line-' + i"
    ishProductContext
    [(quantity)]="model[i].quantity"
    [configuration]="{ quantity: true }"
  >
    <formly-field class="col-8 pr-2" [field]="field"></formly-field>

    <custom-quick-order-quantity
      [lineItemID]="model[i].itemLineId"
      class="col-4 pl-2 quickorder-line-item py-2"
    ></custom-quick-order-quantity>
    <div class="col-3 col-sm-2 quickorder-line-item"></div>
  </div>
</div>
